<header class="site-header">
  <div class="header-inner">
    <a class="brand" (click)="goTo('hero')">
      <img class="brand-logo" src="assets/patagonia-logo.png" alt="Patagonia Chain" />
      <span>
        <span class="brand-name">Patagonia Chain</span>
        <span class="brand-tag">Software</span>
      </span>
    </a>

    <nav class="nav">
      <a (click)="goTo('quienes')">{{ t.nav_quienes }}</a>
      <a (click)="goTo('servicios')">{{ t.nav_servicios }}</a>
      <a (click)="goTo('trabajos')">{{ t.nav_trabajos }}</a>
      <a (click)="goTo('contacto')">{{ t.nav_contacto }}</a>
    </nav>

    <div class="header-actions">
      <div class="lang-toggle">
        <button [class.active]="lang === 'ESP'" (click)="setLang('ESP')">ES</button>
        <button [class.active]="lang === 'ENG'" (click)="setLang('ENG')">EN</button>
      </div>
      <a class="header-cta" href="https://wa.me/+543416902287">{{ t.cta_email }}</a>
      <button class="nav-toggle" (click)="menuOpen = !menuOpen" aria-label="Menú">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
      </button>
    </div>
  </div>
  <div class="mobile-menu" [class.open]="menuOpen">
    <a (click)="goTo('quienes'); menuOpen = false">{{ t.nav_quienes }}</a>
    <a (click)="goTo('servicios'); menuOpen = false">{{ t.nav_servicios }}</a>
    <a (click)="goTo('trabajos'); menuOpen = false">{{ t.nav_trabajos }}</a>
    <a (click)="goTo('contacto'); menuOpen = false">{{ t.nav_contacto }}</a>
  </div>
</header>
